import { createContext, useContext, useState } from "react";
import { SESSION_STORAGE_USER_KEY, USER_PROFILE } from "../lib/constants.js";

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem(SESSION_STORAGE_USER_KEY);

    try {
      return storedUser ? JSON.parse(storedUser) : {};
    } catch (error) {
      console.error("Error parsing user data from sessionStorage.", error);

      return {};
    }
  });

  const canEdit = user.employee?.canEditData;
  const canViewOtherHidden = user.employee?.canViewOtherHidden;
  const isAdmin = user.profile === USER_PROFILE.ADMIN;
  const isEmployee = user.profile === USER_PROFILE.EMPLOYEE;
  const isHost = user.profile === USER_PROFILE.HOST;
  const isTrans = String(user.username) === process.env.REACT_APP_TRANS;
  const hostEmployeeId = isEmployee && user.host?.id;
  const isLoggedIn = Boolean(user.id);
  const runId = user.runId;

  return (
    <UserContext.Provider
      value={{
        canEdit,
        canViewOtherHidden,
        isAdmin,
        isEmployee,
        isHost,
        isTrans,
        hostEmployeeId,
        isLoggedIn,
        runId,
        setUser,
        user,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
